import { ApiService } from "../../constants";
import { HttpService } from "../../utilities";

interface GetMasterBadge {
  search?: string;
  userin?: string;
  scheduleid?: string;
  page?: number;
  size?: number;
}

export const getMasterBadge = ({
  search = "",
  page,
  size,
  scheduleid = "",
  userin = "",
}: GetMasterBadge) => {
  return HttpService.get(
    `${
      ApiService.icdc.module.badge.getList
    }?search=${search}&page=${page}&userin=${userin || ""}`
  );
};

export const postMasterBadge = (data) => {
  return HttpService.post(ApiService.icdc.module.badge.add, data);
};

export const editMasterBadge = (data) => {
  return HttpService.post(ApiService.icdc.module.badge.update, data);
};

export const deleteMasterBadge = (data) => {
  return HttpService.post(ApiService.icdc.module.badge.delete, data);
};

export const saveImage = (data) => {
  return HttpService.post(ApiService.icdc.module.badge.uploadImage, data);
};
